import React from "react";
import { useHistory } from "react-router-dom";

function NotFound() {
  const history = useHistory();
  document.title = "404 | Page Not Found";

  const handleClick = () => {
    history.push("/");
  };
  return (
    <>
      <div className="not-found">
        <h2 className="darktextColor">404</h2>
        <p className="darktextColor">Page Not Found</p>
        <button onClick={handleClick}>Back</button>
      </div>
    </>
  );
}

export default NotFound;
